/* eslint-disable */
import { put, takeEvery, select } from 'redux-saga/effects';
import { closeModal } from 'actions/modal';
import setLoading from 'actions/loading';
import { setCandidateAttachedFile } from 'api/candidates';
import { startAttachedFileSubmit, resolveAttachedFileSubmit } from './actions';
import { moveCandidateToStage } from 'modules/JobBoard/actions';
import { EMPLOYER } from 'constants/index';
import { updateCandidatePropById } from 'modules/Candidates/actions';

export function* attachedFileSaga(action: any) {
  const { token, role } = yield select(state => state.user);
  const {
    attachedFile,
    attachedFileType,
    attachedFilePropName,
    stageId,
    stageTitle,
    candidateId,
  } = action.payload;

  try {
    const attachedFileData = new FormData();
    attachedFileData.append(attachedFileType === 'invoice' ? 'invoice' : 'offer', attachedFile);

    yield put(setLoading(true));

    const attachedFileResult = yield setCandidateAttachedFile(
      role,
      candidateId,
      attachedFileType,
      attachedFileData,
      token
    );

    yield put(setLoading(false));

    yield put(resolveAttachedFileSubmit());

    if (role === EMPLOYER) {
      yield put(moveCandidateToStage({ stageId, stageTitle, candidateId }));
    }

    yield put(
      updateCandidatePropById({
        id: candidateId,
        propName: `${attachedFilePropName}`,
        value: attachedFileResult.data.url,
      })
    );
    yield put(closeModal());
  } catch (error) {
    yield put(setLoading(false));
    yield put(resolveAttachedFileSubmit(error.response));
  }
}

export default function* attachFileSagas() {
  yield takeEvery(startAttachedFileSubmit, attachedFileSaga);
}
